<app-database-lookup-input [inline]="inline" translationPrefix="inventory_number"
                           [allowExisting]="allowExisting" [showExisting]="showExisting" [onlyExisting]="onlyExisting"
                           [allowed]="allowed" [notAllowed]="notAllowed" [boundLookupFunction]="lookupFunction"
                           validatorStringPattern="^0[0-9]{9}$" [invalidPatternRegExp]="invalidPatternRegExp"
                           [exactLength]="10" minLength="10" maxLength="10" [size]="12" inputMode="numeric"
                           type="number" [maxPossibilities]="40" startString="0" [value]="invnr"
                           (valueChange)="valueChange($event)" (valueChosen)="valueChosen($event)"
></app-database-lookup-input>
